const menuItems = {
    auth: {
        to: '/',
        text: 'Авторизация'
    },
    contacts: {
        to: '/contacts',
        text: 'Контакты'
    },
};
export default menuItems;